
import { Component, Prop, Vue } from "nuxt-property-decorator";
import {
  returnPriceFormatDE,
  returPriceTrendFormatDE,
} from "~/mixins/formatting";
import { isPriceInvalid } from "~/utils/priceUtils";
import { getTrendDirection } from "~/utils/trendanalysis";

type AccentColor = "yellow" | "green";
const ACCENT_COLORS: AccentColor[] = ["yellow", "green"];

@Component({})
export default class PelletsPriceCard extends Vue {
  @Prop({ type: String, required: true }) readonly productLabel!: string;
  @Prop({ type: Number, required: true }) readonly price!: number;
  @Prop({ type: Number, required: true }) readonly timestampUnix!: number;
  @Prop({ type: Number, required: true }) readonly delta!: number;
  @Prop({
    type: String,
    default: "yellow",
    validator: (value: string) => ACCENT_COLORS.includes(value as AccentColor),
  })
  readonly accentColor!: AccentColor;
  @Prop({ type: Boolean, required: true }) readonly active!: boolean;

  onToggle(): void {
    this.$emit("toggle");
  }

  get hasValidPrice(): boolean {
    return !isPriceInvalid(this.price);
  }

  get formattedPrice(): string {
    return this.hasValidPrice ? returnPriceFormatDE(this.price) : "--,-- €";
  }

  get formattedDelta(): string {
    if (!this.hasValidPrice || isNaN(this.delta)) {
      return "--,-- €";
    }
    return String(returPriceTrendFormatDE(this.delta));
  }

  get formattedTimestamp(): string {
    if (this.timestampUnix <= 0) {
      return "--:-- Uhr";
    }
    const formatted = new Intl.DateTimeFormat("de-DE", {
      hour: "2-digit",
      minute: "2-digit",
      timeZone: "Europe/Berlin",
    }).format(new Date(this.timestampUnix * 1000));
    return `${formatted} Uhr`;
  }

  get trendDirection(): string {
    return getTrendDirection(this.delta);
  }
}
